import { useId } from 'react'
import './other-ways-to-give.css'

/**
 * The ways to give that do not go through this page — a check, a transfer.
 * Under a hairline beside the heading, because they are a second answer to the
 * page's question rather than a step in its flow.
 */
export function OtherWaysToGive({
  items,
}: {
  items: Array<{ label: string; details: string[] }>
}) {
  const id = useId()
  if (items.length === 0) return null
  return (
    <section className="give__other" aria-labelledby={id}>
      <h2 className="give__other-title" id={id}>
        Other ways to give
      </h2>
      <dl className="give__ways">
        {items.map((item) => (
          <div className="give__way" key={item.label}>
            <dt className="give__way-name">{item.label}</dt>
            {item.details.map((detail) => (
              <dd className="give__way-detail" key={detail}>
                {detail}
              </dd>
            ))}
          </div>
        ))}
      </dl>
    </section>
  )
}
